var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardThunderbolt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3001 10.7716H18.198L23.6852 3.8386C23.7988 3.6918 23.6963 3.47852 23.5107 3.47852H12.8882C12.8106 3.47852 12.7358 3.52006 12.6971 3.58931L5.52028 15.9846C5.43441 16.1314 5.53966 16.3169 5.7114 16.3169H10.5421L8.0658 26.2221C8.01317 26.4381 8.27354 26.5904 8.4342 26.4353L24.4524 11.1511C24.5965 11.0154 24.4995 10.7716 24.3001 10.7716Z",
    fill: "#507ACD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardThunderbolt);
export default __webpack_public_path__ + "static/media/dashboard_thunderbolt.918396185ea7daa87077f6019c29c3d7.svg";
export { ForwardRef as ReactComponent };